<div *ngFor="let item of section.items" class="d-flex justify-content-center">
  <div class="row p-3">
    <img [src]="item?.photo" alt="" class="coverPage rounded" (click)="goLink(item)">
  </div>
</div>